var map = {
	"./multiplier_128_win.png": "db52",
	"./multiplier_16_win.png": "522d",
	"./multiplier_1_win.png": "7bd7",
	"./multiplier_2_win.png": "b902",
	"./multiplier_32_win.png": "9ea8",
	"./multiplier_4_win.png": "279b",
	"./multiplier_64_win.png": "df59",
	"./multiplier_8_win.png": "6113"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9a8";